var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AskDataSharingContentProvider = void 0;
var messages_1 = require("../../../messages");
var MessagesWithEscapedMarkdown_1 = require("../../MessagesWithEscapedMarkdown");
var SharingContentProvider_1 = require("../SharingContentProvider");
var AskDataSharingContentProvider = (function (_super) {
    __extends(AskDataSharingContentProvider, _super);
    function AskDataSharingContentProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AskDataSharingContentProvider.prototype.getNotificationTitle = function (notification) {
        var _a;
        return MessagesWithEscapedMarkdown_1.MessagesWithEscapedMarkdown(messages_1.Messages.sharingTitle, {
            USER_NAME: (_a = notification.senderDisplayName) !== null && _a !== void 0 ? _a : messages_1.Messages.userRemoved(),
            CONTENT_TYPE: messages_1.Messages.visualizationLowerCase(),
            CONTENT_NAME: notification.content.NLG,
        });
    };
    return AskDataSharingContentProvider;
}(SharingContentProvider_1.SharingContentProvider));
exports.AskDataSharingContentProvider = AskDataSharingContentProvider;
//# sourceMappingURL=AskDataSharingContentProvider.js.map